import { set } from '@vueuse/core';
import { mapStores } from 'pinia';
import { useGlobalStore } from '~/stores/global'
import { useDropdownStore } from '~/stores/dropdown';

export default {
    setup() {
       
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        lbl: {
            type: String,
            required: true
        },
        defaultValue: {
            type: String,
            required: false
        },
        readValue: {
            type: String,
            required: true
        },
        isSearchInside: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isDropdownOpen: false,
            searchQuery: '',
            selectedIndex: 0,
            foundResult: true,
            selectedText: this.defaultValue
        };
    },
    computed: {
        ...mapStores(useGlobalStore),
        isMobile() {
            return this.globalStore.isMobile
        },
        filteredOptions() {
            if (this.foundResult)
                return this.options;
            else {
                return this.options.filter(option =>
                    option[this.readValue].includes(this.searchQuery)
                );
            }
        }
    },
    emits: ["optionSelected"],
    methods: {
        clearSearchQuery() {
            this.searchQuery = '';
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
            if (this.isDropdownOpen) {
                this.scrollIntoView()
            } else {
                this.clearSearchQuery()
            }
        },
        selectOption(option, isTriggeredPinia) {
            // this.searchQuery = option[this.readValue];
            if (isTriggeredPinia !== undefined && isTriggeredPinia) {
                option = this.filteredOptions.find(a => a[this.readValue] === option.toString())

                if (option === undefined)
                    return;
            }

            this.selectedText = option[this.readValue];
            this.foundResult = true;
            const index = this.options.indexOf(this.options.find(option => option[this.readValue] === this.selectedText))
            this.selectedIndex = index > 0 ? index : 0

            if (isTriggeredPinia === undefined || !isTriggeredPinia) {
                this.$emit('optionSelected', option);

                this.toggleDropdown();
            }
        },
        handleKeyDown(event) {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter') {
                event.preventDefault();
            }
            if (event.key === 'ArrowDown' && this.selectedIndex < this.filteredOptions.length - 1) {
                this.selectedIndex++;
                this.scrollIntoView();
            } else if (event.key === 'ArrowUp' && this.selectedIndex > 0) {
                this.selectedIndex--;
                this.scrollIntoView();
            } else if (event.key === 'Enter' && this.selectedIndex >= 0) {
                this.selectOption(this.filteredOptions[this.selectedIndex]);
            } else if (event.key !== 'ArrowDown' || event.key !== 'ArrowUp' || event.key !== 'Enter') {
                this.highLightSelectedIndex()
                this.scrollIntoView();
                this.foundResult = false
            }
        },
        highLightSelectedIndex() {
            const foundResults = this.filteredOptions.find(option => option[this.readValue] === this.selectedText)
            const index = foundResults?.length ? this.filteredOptions.indexOf(foundResults[0]) : 0;
            this.selectedIndex = index
        },
        sortElement() {
            const elements = this.$refs.optionItem;
            elements.sort((a, b) => {
                const idA = parseInt(a.id.slice(2));
                const idB = parseInt(b.id.slice(2));
                return idA - idB;
            });
        },
        scrollIntoView() {
            if (0 <= this.selectedIndex && this.selectedIndex < this.$refs?.optionItem?.length) {
                this.sortElement();
                this.$nextTick(() => {
                    this.$refs.optionItem[this.selectedIndex].scrollIntoView({
                        behavior: 'auto',
                        block: 'nearest',
                    });
                })
            }
        },
        handleClickOutside(event) {
            if (!this.$refs.dropdown?.contains(event.target) && !this.$refs.clearButton?.contains(event.target)) {
                this.isDropdownOpen = false;
                this.clearSearchQuery()
            }
        },
        mobileHandleClickOutside() {
            if (this.isMobile) {
                this.isDropdownOpen = false
                this.clearSearchQuery()
            }
        }
    },
    mounted() {
        if (!this.isMobile) {
            document.addEventListener('click', this.handleClickOutside);
        }

        const dropdownStore = useDropdownStore();
        watch(
            () => dropdownStore.message,
            () => {
                this.selectOption(dropdownStore.message, true);
            }
        );
    },
    beforeUnmount() {
        if (!this.isMobile) {
            document.removeEventListener('click', this.handleClickOutside);
        }
    },
};